let enabled = false;

export const isContractCurrencyValidationEnabled = () => enabled;

export const setContractCurrencyValidation = (value: boolean) => {
  enabled = value;
};
